import React, { useEffect, useState, useContext, Fragment } from "react";
import {
  Typography,
  Stack,
  Box,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Grid,
  TextField,
  Avatar,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
//date picker
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
//Srcs
import "../Style/pagestyle.scss";
import CreateIcon from "../Assets/create-icon.svg";
import EmptyData from "../Components/Include/EmptyData";
import FooterPagination from "../Components/Include/FooterPagination";
import LoadingPage from "../Components/Include/LoadingPage";
import { AuthContext } from "../Context/AuthContext";
import { translateLauguage } from "../Function/Translate";
import { GET_DISBURSEMENTS_WITH_PAGINATION } from "../Schema/Disbursement";
import PayDisbursementAction from "../Components/PayDisbursement/PayDisbursementAction";
import CreatePayDisbursement from "../Components/PayDisbursement/CreatePayDisbursement";

export default function PayDisbursement() {
  // Change Language
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const [loading, setLoading] = useState(true);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [tableData, setTableData] = useState([]);
  const [paginationData, setPaginationData] = useState([]);

  const { refetch } = useQuery(GET_DISBURSEMENTS_WITH_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      from: fromDate ? moment(fromDate).format("YYYY-MM-DD") : "",
      to: toDate ? moment(toDate).format("YYYY-MM-DD") : "",
    },
    onCompleted: ({ getDisbursementsPagination }) => {
      // console.log("getDisbursementsPagination::", getDisbursementsPagination);
      setTableData(getDisbursementsPagination?.data);
      setPaginationData(getDisbursementsPagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
    setLoading(true);
  };

  useEffect(() => {
    refetch();
  }, [fromDate, toDate]);

  // ============================ Resize width Screen ==========================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);
  // ============================ Resize width Screen ==========================

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>

        <Stack direction="column" justifyContent="center">
          <Link className="page-link-title" to="/expense/disbursement">
            <Typography className="page-title">Pay Disbursement</Typography>
          </Link>
        </Stack>

        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" spacing={0.6}>
          <Stack direction="column" justifyContent="center">
            <Link className="page-link-title" to="/">
              {t("page_dashboard")}
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">/</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">
              Pay-Disbursement
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container rowSpacing={1} columnSpacing={3}>
          <Grid item xs={6} sm={6} md={3} lg={2.4} xl={2.4}>
            <Typography className="search-head-title">From</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={fromDate}
                inputFormat="dd-MM-yyyy"
                className="select-date"
                onChange={(newValue) => {
                  setLoading(true);
                  setFromDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={6} sm={6} md={3} lg={2.4} xl={2.4}>
            <Typography className="search-head-title">To</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={toDate}
                inputFormat="dd-MM-yyyy"
                className="select-date"
                onChange={(newValue) => {
                  setLoading(true);
                  setToDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid>

          {/* <Box flexGrow={1} /> */}

          {/* <Grid item xs={12} sm={12} md={4} lg={7.2} xl={7.2}>
            <Stack direction="row" spacing={2} justifyContent="right">
              <Button
                onClick={handleOpen}
                className="btn-export"
                startIcon={
                  <img src={CreateIcon} alt="CreateIcon" className="icon-add" />
                }
              >
                {t("create")}
              </Button>
              <CreatePayDisbursement
                open={open}
                handleClose={handleClose}
                // setRefetch={refetch}
              />
            </Stack>
          </Grid> */}
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableCell className="header-title-start">Date</TableCell>
              <TableCell className="header-title">Numbering</TableCell>
              <TableCell className="header-title">Created By</TableCell>
              <TableCell className="header-title">Updated By</TableCell>
              <TableCell className="header-title">Last Save At</TableCell>
              <TableCell className="header-title-end"></TableCell>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell colSpan={7} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={7} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody className="body">
                      {tableData?.map((row, index) => {
                        // console.log("row::", row);
                        return (
                          <TableRow className="body-row" key={index}>
                            <TableCell className="body-cell-start">
                              {moment(row?.date).format("DD-MMM-YYYY")}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.numbering}
                            </TableCell>
                            <TableCell className="body-cell">
                              <Stack direction="row" spacing={1}>
                                <Avatar
                                  sx={{ width: "40px", height: "40px" }}
                                  src={row?.createBysrc}
                                />
                                <Stack
                                  direction="column"
                                  justifyContent="center"
                                >
                                  {row?.createBy}
                                </Stack>
                              </Stack>
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.updatedBysrc ? (
                                <Stack direction="row" spacing={1}>
                                  <Avatar
                                    sx={{ width: "40px", height: "40px" }}
                                    src={row?.updatedBysrc}
                                  />
                                  <Stack
                                    direction="column"
                                    justifyContent="center"
                                  >
                                    {row?.updatedBy}
                                  </Stack>
                                </Stack>
                              ) : (
                                "----- : -----"
                              )}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.lastSaveAt?.date
                                ? `${moment(row?.lastSaveAt?.date).format(
                                    "DD-MMM-YYYY"
                                  )}, ${row?.lastSaveAt?.time}`
                                : "----- : -----"}
                            </TableCell>

                            <TableCell className="body-cell-end" align="right">
                              <PayDisbursementAction
                                editData={row}
                                setRefetch={refetch}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </>
                )}
              </>
            )}
          </Table>
        </TableContainer>

        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
        />
      </Box>
    </div>
  );
}
